"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLienAttestationType = void 0;
/** @TranslateToPython @TranslateToEnum */
var UserLienAttestationType;
(function (UserLienAttestationType) {
    UserLienAttestationType["FIRST"] = "FIRST";
    UserLienAttestationType["SECOND"] = "SECOND";
    UserLienAttestationType["MULTI_LIEN"] = "MULTI_LIEN";
})(UserLienAttestationType || (exports.UserLienAttestationType = UserLienAttestationType = {}));
